export default {
    visBoxDistribuir(state, payload) {
        if (!state.boxFirst) {
            //console.log('~@@@ distribuir: nenhum first box selecionado')
            return;
        }

        if (state.boxesSelected().length < 3) {
            //console.log('~@@@ distribuir: menos de 3 boxes selecionados')
            return;
        }

        let validou = false;

        function getBoxes(selecao) {

            return state.boxesSelected().reduce(
                function(acumulador, objeto) {
            
                    if (acumulador.idx == undefined) {
                        acumulador.idx = objeto.idx;
                        acumulador.pos.x = objeto.perc.x;
                        
                        acumulador.pos.y = objeto.perc.y;
                        return acumulador;
                    }

                    let pos = 0,
                        prop = 'x';
                    switch (selecao) {
                        case 'MIN-LEFT':
                            pos = objeto.perc.x;
                            validou = pos < acumulador.pos.x;
                            break;
                        case 'MAX-LEFT':
                            pos = objeto.perc.x;
                            validou = pos > acumulador.pos.x;
                            break;
                        case 'LEFT-MIDDLE':
                            pos = objeto.perc.x + (objeto.perc.w / 2);
                            validou = pos < acumulador.pos.x;
                            break;
                        case 'MIN-RIGHT':
                            pos = objeto.perc.x + objeto.perc.w;
                            validou = pos < acumulador.pos.x;
                            break;
                        case 'MAX-RIGHT':
                            pos = objeto.perc.x + objeto.perc.w;
                            validou = pos > acumulador.pos.x;
                            break;
                        case 'RIGHT-MIDDLE':
                            pos = objeto.perc.x + (objeto.perc.w / 2);
                            validou = pos > acumulador.pos.x;
                            break;


                        case 'MIN-TOP':
                            pos = objeto.perc.y;
                            validou = pos < acumulador.pos.y;
                            prop = 'y';
                            break;
                        case 'MAX-TOP':
                            pos = objeto.perc.y;
                            validou = pos > acumulador.pos.y;
                            prop = 'y';
                            break;
                        case 'TOP-MIDDLE':
                            pos = objeto.perc.y + (objeto.perc.h / 2);
                            validou = pos < acumulador.pos.y;
                            prop = 'y';
                            break;


                        case 'MIN-BOTTOM':
                            pos = objeto.perc.y + objeto.perc.h;
                            validou = pos < acumulador.pos.y;
                            prop = 'y';
                            break;
                        case 'MAX-BOTTOM':
                            pos = objeto.perc.y + objeto.perc.h;
                            validou = pos > acumulador.pos.y;
                            prop = 'y';
                            break;
                        case 'BOTTOM-MIDDLE':
                            pos = objeto.perc.y + (objeto.perc.h / 2);
                            validou = pos > acumulador.pos.y;
                            prop = 'y';
                            break;
                    }

                    if (validou) {
                        acumulador.idx = objeto.idx;
                        acumulador.pos[prop] = pos;
                    }
                    return acumulador;

                }, {
                    idx: null,
                    pos: {
                        x: 0,
                        y: 0
                    }
                }
            )
        }


        //console.log('max-left', getBoxes('MAX-LEFT'), 'max-right', getBoxes('MAX-RIGHT'))
        //console.log('max-top', getBoxes('MAX-TOP'), 'max-bottom', getBoxes('MAX-BOTTOM'))

        //console.log('max-left-middle', getBoxes('MAX-LEFT-MIDDLE'), 'max-right-middle', getBoxes('MAX-RIGHT-MIDDLE'))
        //console.log('max-top-middle', getBoxes('MAX-TOP-MIDDLE'), 'max-bottom-middle', getBoxes('MAX-BOTTOM-MIDDLE'))

        //console.log('----')

        function evitaEstouroVertical(pos, box) {
            //verificacao de estouro
            if (pos < 0)
                pos = 0;
            else
            if (pos > payload.painel.percAlturaDinamica())
                pos = payload.painel.percAlturaDinamica() - Box[this.percProp].h;
            return pos;
        }

        function evitaEstouroHorizontal(pos, box) {
            //verificacao de estouro
            if (pos < 0)
                pos = 0;
            else
            if (pos > 100)
                pos = 100 - Box[this.percProp].h;
            return pos;
        }

        let divisor = state.boxesSelected().length - 1;
        switch (payload.tipo) {
            case 'VERT-TOP':
                {
                    let box1 = state.boxes.value[getBoxes('MIN-TOP').idx];
                    let box2 = state.boxes.value[getBoxes('MAX-TOP').idx];

                    let passo = (box2.perc.y - box1.perc.y) / divisor;
                    let etapa = 1;

                    state.boxesSelected().forEach(b => {
                        if (b.idx == box1.idx || b.idx == box2.idx)
                            return;

                        let pos = box1.perc.y + (etapa * passo);

                        //verificacao de estouro
                        b.perc.y = evitaEstouroVertical(pos, b);
                        etapa++;
                    });
                    break;
                }

            case 'VERT-MIDDLE':
                {
                    let box1 = state.boxes.value[getBoxes('TOP-MIDDLE').idx];
                    let box2 = state.boxes.value[getBoxes('BOTTOM-MIDDLE').idx];

                    let passo = ((box2.perc.y + (box2.perc.h / 2)) - (box1.perc.y + (box1.perc.h / 2))) / divisor;
                    let etapa = 1;

                    state.boxesSelected().forEach(b => {
                        if (b.idx == box1.idx || b.idx == box2.idx)
                            return;

                        let pos = (box1.perc.y + (box1.perc.h / 2)) + (etapa * passo) - (b.perc.h / 2);

                        //verificacao de estouro
                        b.perc.y = evitaEstouroVertical(pos, b);
                        etapa++;
                    });
                    break;
                }

            case 'VERT-BOTTOM':
                {
                    let box1 = state.boxes.value[getBoxes('MIN-BOTTOM').idx];
                    let box2 = state.boxes.value[getBoxes('MAX-BOTTOM').idx];

                    let passo = ((box2.perc.y + box2.perc.h) - (box1.perc.y + box1.perc.h)) / divisor;
                    let etapa = 1;

                    state.boxesSelected().forEach(b => {
                        if (b.idx == box1.idx || b.idx == box2.idx)
                            return;

                        let pos = box1.perc.y + box1.perc.h + (etapa * passo);

                        //verificacao de estouro
                        b.perc.y = evitaEstouroVertical(pos, b);
                        etapa++;
                    });
                    break;
                }



            case 'HOR-LEFT':
                {
                    let box1 = state.boxes.value[getBoxes('MIN-LEFT').idx];
                    let box2 = state.boxes.value[getBoxes('MAX-LEFT').idx];

                    let passo = (box2.perc.x - box1.perc.x) / divisor;
                    let etapa = 1;

                    state.boxesSelected().forEach(b => {
                        if (b.idx == box1.idx || b.idx == box2.idx)
                            return;
                        let pos = box1.perc.x + (etapa * passo)

                        //verificacao de estouro
                        b.perc.x = evitaEstouroHorizontal(pos, b);
                        etapa++;
                    });
                    break;
                }

            case 'HOR-MIDDLE':
                {
                    let box1 = state.boxes.value[getBoxes('LEFT-MIDDLE').idx];
                    let box2 = state.boxes.value[getBoxes('RIGHT-MIDDLE').idx];

                    let passo = ((box2.perc.x + (box2.perc.w / 2)) - (box1.perc.x + (box1.perc.w / 2))) / divisor;
                    let etapa = 1;

                    state.boxesSelected().forEach(b => {
                        if (b.idx == box1.idx || b.idx == box2.idx)
                            return;

                        let pos = (box1.perc.x + (box1.perc.w / 2)) + (etapa * passo) - (b.perc.w / 2);

                        //verificacao de estouro
                        b.perc.x = evitaEstouroHorizontal(pos, b);

                        etapa++;
                    });
                    break;
                }

            case 'HOR-RIGHT':
                {
                    let box1 = state.boxes.value[getBoxes('MIN-RIGHT').idx];
                    let box2 = state.boxes.value[getBoxes('MAX-RIGHT').idx];

                    let passo = ((box2.perc.x + box2.perc.w) - (box1.perc.x + box1.perc.w)) / divisor;
                    let etapa = 1;

                    state.boxesSelected().forEach(b => {
                        if (b.idx == box1.idx || b.idx == box2.idx)
                            return;

                        let pos = box1.perc.x + box1.perc.w + (etapa * passo);

                        //verificacao de estouro
                        pos = evitaEstouroVertical(pos, b);

                        b.perc.x = pos;
                        etapa++;
                    });
                    break;
                }


            default:
                break;
        }

    }
}